import SwiperLinked from '../../components/swiper/linked';

const widgetInstances = document.querySelectorAll('.widget--carousel-text');

widgetInstances.forEach((widget) => {
  const swiperEls = widget.querySelectorAll('.swiper');

  // eslint-disable-next-line no-new
  if (swiperEls.length > 0) new SwiperLinked(swiperEls);
});
